import { render, staticRenderFns } from "./abastecimentoReportModel.vue?vue&type=template&id=66781962&scoped=true"
import script from "./abastecimentoReportModel.vue?vue&type=script&lang=js"
export * from "./abastecimentoReportModel.vue?vue&type=script&lang=js"
import style0 from "./abastecimentoReportModel.vue?vue&type=style&index=0&id=66781962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66781962",
  null
  
)

export default component.exports